import { Monitor, Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Listbox } from '@/components/ui/listbox';
import { useTheme, type ThemePreference } from '@/stores/theme-store';

/**
 * Light, dark or follow the device — gallery control for widget review.
 *
 * Product surfaces use the same preference via the account menu Appearance submenu.
 */
export const ThemeToggle = () => {
  const { t } = useTranslation();
  const preference = useTheme((state) => state.preference);
  const setPreference = useTheme((state) => state.setPreference);

  return (
    <div className="w-48">
      <Listbox<ThemePreference>
        value={preference}
        onChange={(next) => next && setPreference(next)}
        aria-label={t('theme.label')}
        options={[
          { value: 'light', label: t('theme.light'), icon: <Sun className="h-4 w-4" /> },
          { value: 'dark', label: t('theme.dark'), icon: <Moon className="h-4 w-4" /> },
          { value: 'system', label: t('theme.system'), icon: <Monitor className="h-4 w-4" /> },
        ]}
      />
    </div>
  );
};
